import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import promiseMiddleware from "redux-promise-middleware";

import home, { HomeState } from "./home/reducer";
import signin, { SignInState } from "./signin/reducer";
import settings, { SettingsState } from "./settings/reducer";
import createSystem, { CreateSystemState } from "./system/reducer";
import error, { ErrorState } from "./error/reducer";
import about, { AboutState } from "./about/reducer";
import faq, { FaqState } from "./faq/reducer";

//@ts-ignore
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(promiseMiddleware));

export interface State {
	home: HomeState;
	signin: SignInState;
	settings: SettingsState;
	createSystem: CreateSystemState;
	error: ErrorState;
	about: AboutState;
	faq: FaqState;
}

const reducers = combineReducers({
	home,
	signin,
	settings,
	createSystem,
	error,
	about,
	faq,
});

const rootReducer = (state, action) => {
	if (action.type === "USER_ACTIONS.SIGN_OUT")
		return reducers(undefined, action);
	return reducers(state, action);
};

export default createStore(rootReducer, enhancer);
